import React, { useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Spinner,
  useToast,
  VStack,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  HStack,
} from '@chakra-ui/react';
import {
  sendGlobalNotification,
  scheduleNotification,
  getAllNotifications,
  deleteNotification,
} from '../../../services/notificationService';
import CustomSpinner from '../../EndedAuctions/CustomSpinner';

const NotificationManager = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const [formData, setFormData] = useState({
    title: '',
    message: '',
    sendAt: '',
    // adminId: '',
     // This should be set to the current logged-in admin's ID
  });
  const [isScheduling, setIsScheduling] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const { data, isLoading, isError, error } = useQuery('notifications', getAllNotifications);
console.log(data?.data?.notifications)
  const sendNotificationMutation = useMutation(sendGlobalNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications');
      toast({
        title: 'Notification sent.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      setIsSending(false);
    },
    onError: (error) => {
      toast({
        title: 'Error sending notification',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setIsSending(false);
    },
  });

  const scheduleNotificationMutation = useMutation(scheduleNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications');
      toast({
        title: 'Notification scheduled.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      setIsScheduling(false);
    },
    onError: (error) => {
      toast({
        title: 'Error scheduling notification',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setIsScheduling(false);
    },
  });

  const deleteNotificationMutation = useMutation(deleteNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications');
      toast({
        title: 'Notification deleted.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: 'Error deleting notification',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSend = () => {
    setIsSending(true);
    sendNotificationMutation.mutate(formData);
  };

  const handleSchedule = () => {
    setIsScheduling(true);
    scheduleNotificationMutation.mutate(formData);
  };

  const handleDelete = (id) => {
    deleteNotificationMutation.mutate(id);
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (isError) {
    return <Box color="red.500">Error: {error.message}</Box>;
  }

  return (
    <Box p={4}>
      <VStack spacing={4} width="100%">
        <FormControl id="title" isRequired>
          <FormLabel>Title</FormLabel>
          <Input name="title" value={formData.title} onChange={handleChange} />
        </FormControl>
        <FormControl id="message" isRequired>
          <FormLabel>Message</FormLabel>
          <Textarea name="message" value={formData.message} onChange={handleChange} />
        </FormControl>
        <FormControl id="sendAt">
          <FormLabel>Send At</FormLabel>
          <Input
            name="sendAt"
            type="datetime-local"
            value={formData.sendAt}
            onChange={handleChange}
          />
        </FormControl>
        <HStack spacing={4}>
          <Button colorScheme="blue" onClick={handleSend} isLoading={isSending}>
            Send Now
          </Button>
          <Button
            colorScheme="green"
            onClick={handleSchedule}
            isLoading={isScheduling}
            disabled={!formData.sendAt}
          >
            Schedule
          </Button>
        </HStack>
        <Table mt={8}>
          <Thead>
            <Tr>
              <Th>Title</Th>
              <Th>Message</Th>
              <Th>Send At</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.data?.notifications?.map((notification) => (
              <Tr key={notification._id}>
                <Td>{notification.title}</Td>
                <Td>{notification.message}</Td>
                <Td>{new Date(notification.sendAt).toLocaleString()}</Td>
                <Td>
                  <Button
                    colorScheme="red"
                    onClick={() => handleDelete(notification._id)}
                    // isLoading={deleteNotificationMutation.isLoading}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </VStack>
    </Box>
  );
};

export default NotificationManager;
